import React from 'react';
import { Row, Col } from 'antd';
import DetailItem from "./../../../../CSIComponents/DetailItem";

interface propsTypes {
  dataList: void | any
}
const GeneralView = (props: propsTypes) => {
  const translateToYesOrNo = (data: string) => data === 'true' ? 'Yes' : (data === 'false' ? 'No' : '')

  const data = props.dataList?.environmentalimpact?.energyusage?.general || {};
  const inputList = [
    { label: 'Efficient Appliances', name: translateToYesOrNo(data.efficientappliances) },
    { label: 'Efficient Lighting', name: translateToYesOrNo(data.efficientlighting) },
    { label: 'Heat/Power Combined', name: translateToYesOrNo(data.heatpowercombined) },
    {},
    { label: 'Heat Pump', name: translateToYesOrNo(data.heatpump) },
    { label: 'Power Saving Policy', name: translateToYesOrNo(data.powersavingpolicy) },
    { label: 'Solar', name: translateToYesOrNo(data.solar) },
    {},
    { label: 'Temperature Controls', name: translateToYesOrNo(data.tempcontrols) },
    { label: 'Wind Turbine', name: translateToYesOrNo(data.windturbine) },
    { label: 'Energy Generated Amount', name: data.energygeneratedamount },
    {},
    { label: 'Energy Star Rating', name: data.energystarrating },
    { label: 'Energy Intensity Amount', name: data.energyintensityamount },
    { label: 'Energy Intensity Unit Of Measure', name: data.energyintensityuom },
    {},
    { label: 'Energy Intensity Time Period', name: data.energyintensitytimeperiod },
  ]
  return (
    <>
      <Row gutter={24}>
        {
          inputList.map((item, i) => {
            return (
              item.label
                ? <Col style={{ marginBottom: '30px' }} span={6} key={i}>
                  <DetailItem value={item.name} label={item.label} />
                </Col>
                : <Col span={5} key={i}></Col>
            )
          })
        }
      </Row>
    </>
  )
}


export default GeneralView;